import { ListGroup } from "react-bootstrap"
import { FaRegClock } from "react-icons/fa"

import NotificationEvent from "../../../api/Randoms/Notification/NotificationEvent"

interface NotificationEventsCellProps {
  types: NotificationEvent[]
}

function NotificationEventsCell({ types }: NotificationEventsCellProps) {
  return (
    <>
      {types?.length > 0 && (
        <ListGroup>
          {types.map((x) => (
            <ListGroup.Item
              key={`${x.Code}-icon-type`}
              className="bg-transparent border-0 p-0 d-flex align-items-center"
            >
              <FaRegClock className="text-notification mr-2" />
              <span className="d-inline-block text-truncate" style={{ maxWidth: "350px" }}>
                {x.Description}
              </span>
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
    </>
  )
}

export default NotificationEventsCell
